import { Centered } from '@studio/design-system/overlay';
import { Spinner } from '@studio/design-system/spinner';
import { useTimer } from '@studio/react-utils/hooks';
import type { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';

/** `<Unlink>` component. */
export const Unlink = (): ReactElement => {
  const navigate = useNavigate();

  // Wait a few seconds for the the agent to be unlinked.  The launcher does not provide us with any useful feedback, so this is @fixme hack.
  useTimer(() => {
    navigate('/');
  }, 5e3);

  return (
    <Centered>
      <div className='flex items-center gap-8 text-xl'>
        <Spinner /> Unlinking agent...
      </div>
    </Centered>
  );
};
